import { render } from "./BrandCulture.vue?vue&type=template&id=ce8dcdba&scoped=true&ts=true"
import script from "./BrandCulture.vue?vue&type=script&lang=ts"
export * from "./BrandCulture.vue?vue&type=script&lang=ts"

import "./BrandCulture.vue?vue&type=style&index=0&id=ce8dcdba&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8dcdba"]])

export default __exports__